<span class="empty-message__icon">
  <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
</span>
{{ text() }}
